<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_quesiton") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            col="6"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.category')"
            v-model.trim="data.categories"
            required
            multiple
          />
          <base-select-input
            col="6"
            :optionsList="types"
            :placeholder="$t('PLACEHOLDERS.type')"
            v-model.trim="data.type"
            required
          />

          <base-image-upload-input
            col="12"
            v-if="data.type?.value == 'video'"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_question')"
            :acceptVideo="true"
            @selectImage="selectVideo"
            :preSelectedImage="data.video.path"
          />
          <UploadAudio
            col="12"
            v-if="data.type?.value == 'record'"
            identifier="record"
            :placeholder="$t('PLACEHOLDERS.record_question')"
            :accepctAudio="true"
            @selectAudio="selectAudio"
            :multiple="false"
            :urls="[data.record]"
          />
          <UploadsPhotos
            col="12"
            v-if="data.type?.value == 'image'"
            identifier="images"
            :urls="imgUrls"
            multiple
            :placeholder="$t('PLACEHOLDERS.image')"
            :acceptVideo="true"
            @onFileSelect="selectImages"
            @onFileRemove="onFileRemove"
          />
          <!-- <base-input
            col="6"
            v-if="data.type"
            :type="data.type?.value != 'text' ? 'text' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_english'
                  : 'PLACEHOLDERS.descEn'
              )
            "
            v-model.trim="data.questionEn"
            required
          /> -->

          <base-input
            col="6"
            v-if="data.type"
            :type="data.type?.value != 'text' ? 'text' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_arabic'
                  : 'PLACEHOLDERS.descAr'
              )
            "
            v-model.trim="data.questionAr"
            required
          />

          <base-select-input
            col="7"
            :optionsList="levels"
            :placeholder="$t('PLACEHOLDERS.level')"
            v-model="data.level"
          />

          <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_arabic')"
            v-model.trim="data.answerAr"
            required
          />
          <!-- <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_english')"
            v-model.trim="data.answerEn"
            required
          /> -->
          <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.hint_text_arabic')"
            v-model.trim="data.hintAr"
            required
          />
          <!-- <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.hint_text_english')"
            v-model.trim="data.hintEn"
            required
          /> -->
          <div class="row">
            <!-- <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.first_answer_text_english')"
              v-model.trim="data.helping_answersEn[0]"
              required
            /> -->
            <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.first_answer_text_arabic')"
              v-model.trim="data.helping_answersAr[0]"
              required
            />
            <!-- <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.second_answer_text_english')"
              v-model.trim="data.helping_answersEn[1]"
              required
            /> -->
            <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.second_answer_text_arabic')"
              v-model.trim="data.helping_answersAr[1]"
              required
            />
            <!-- <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.third_answer_text_english')"
              v-model.trim="data.helping_answersEn[2]"
              required
            /> -->
            <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.third_answer_text_arabic')"
              v-model.trim="data.helping_answersAr[2]"
              required
            />
            <!-- <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.fourth_answer_text_english')"
              v-model.trim="data.helping_answersEn[3]"
              required
            /> -->
            <base-input
              col="6"
              :type="'textarea'"
              :placeholder="$t('PLACEHOLDERS.fourth_answer_text_arabic')"
              v-model.trim="data.helping_answersAr[3]"
              required
            />
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import UploadAudio from "../../../components/formInputs/UploadAudio.vue";

export default {
  name: "CreateAdmin",
  components: { ChangableMapComponent, UploadsPhotos, UploadAudio },
  data() {
    return {
      initialType: null,
      isWaitingRequest: false,
      categories: [],
      imgUrls: [],

      data: {
        questionAr: "",
        questionEn: "",
        answerAr: "",
        answerEn: "",
        hintAr: "",
        hintEn: "",
        level: "",
        helping_answersEn: ["", "", "", ""],
        helping_answersAr: ["", "", "", ""],
        record: {
          path: null,
          file: null,
        },
        video: {
          path: null,
          file: null,
        },
        images: [
          {
            path: null,
            file: null,
          },
        ],

        categories: [],
        type: null,
      },
      types: [
        {
          value: "text",
          name: this.$t("PLACEHOLDERS.text_queston"),
        },
        {
          value: "video",
          name: this.$t("PLACEHOLDERS.video_question"),
        },
        {
          value: "image",
          name: this.$t("PLACEHOLDERS.image_question"),
        },
        {
          value: "record",
          name: this.$t("PLACEHOLDERS.record"),
          id: "record",
        },
      ],
      levels: [
        {
          name: this.$t("PLACEHOLDERS.low"),
          value: "easy",
        },
        {
          name: this.$t("PLACEHOLDERS.medium"),
          value: "medium",
        },
        {
          name: this.$t("PLACEHOLDERS.hard"),
          value: "hard",
        },
      ],
      // End:: Data Collection To Send
    };
  },

  methods: {
    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "categories?isActive=1&page=0&limit=0",
        });

        this.categories = res.data.data.data;
      } catch (error) {
        this.loading = false;
      }
    },

    addRow() {
      this.data?.experiences.push({
        company_name: null,
        years: null,
        from_date: null,
        to_date: null,
      });
    },

    removeRow(index) {
      this.data?.experiences.splice(index, 1);
    },
    selectImages(selectedImage) {
      this.data.images = [...this.data.images, ...selectedImage];
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.data.images[index]?.id;
      console.log(imageId);

      if (!imageId) return;
      try {
        await this.$axios({
          method: "DELETE",
          url: `delete-media/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }

      this.data.filter.images.filter((image, i) => index != i);
    },
    selectVideo(selectedVideo) {
      this.data.video = selectedVideo;
    },
    selectAudio(selectedAudio) {
      this.data.record = {
        file: selectedAudio[0],
        path: null,
      };
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.type.value == "record" && this.data.record.file) {
        REQUEST_DATA.append("record", this.data.record.file);
      }
      if (this.data.type.value == "video" && this.data.video.file) {
        REQUEST_DATA.append("video", this.data.video.file);
      }
      if (this.data.type.value == "image" && this.data.images) {
        this.data.images.map((image) => {
          if (!image.path) REQUEST_DATA.append("images[]", image);
        });
      }
      if (this.data?.type && this.data.type?.value != this.initialType) {
        REQUEST_DATA.append("type", this.data.type?.value);
      }

      if (this.data.categories) {
        this.data.categories.forEach((category) => {
          REQUEST_DATA.append("category_ids[]", category.id);
        });
      }

      if (this.data.questionAr) {
        REQUEST_DATA.append("question[ar]", this.data.questionAr);
      }
      if (this.data.questionEn) {
        REQUEST_DATA.append("question[en]", this.data.questionEn);
      }
      if (this.data.answerAr) {
        REQUEST_DATA.append("answer[ar]", this.data.answerAr);
      }
      if (this.data.answerEn) {
        REQUEST_DATA.append("answer[en]", this.data.answerEn);
      }
      if (this.data.hintAr) {
        REQUEST_DATA.append("hint[ar]", this.data.hintAr);
      }
      if (this.data.hintAr) {
        REQUEST_DATA.append("hint[en]", this.data.hintEn);
      }
      if (this.data.level) {
        REQUEST_DATA.append("level", this.data.level?.value);
      }

      if (this.data.helping_answersAr) {
        this.data.helping_answersAr.forEach((answer, i) => {
          REQUEST_DATA.append(`helping_answers[ar][${i}]`, answer);
        });
      }

      if (this.data.helping_answersEn) {
        this.data.helping_answersEn.forEach((answer, i) => {
          REQUEST_DATA.append(`helping_answers[en][${i}]`, answer);
        });
      }
      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `questions/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/questions/all" });
      } catch (error) {
        console.log(error);
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `questions/${this.$route.params.id}`,
        });
        this.data.categories = res.data.data.data.categories;
        this.data.video.path = res.data.data.data.video;

        this.data.record.path = res.data.data.data?.record;
        this.data.questionAr = res.data.data.data.question_ar;
        this.data.questionEn = res.data.data.data.question_en;
        this.data.descAr = res.data.data.data.description_ar;
        this.data.descEn = res.data.data.data.description_en;
        this.data.answerAr = res.data.data.data.answer_ar;
        this.data.answerEn = res.data.data.data.answer_en;
        this.data.hintAr = res.data.data.data.hint_ar;
        this.data.hintEn = res.data.data.data.hint_en;
        this.data.helping_answersAr = res.data.data.data.helping_answers_ar;
        this.data.helping_answersEn = res.data.data.data.helping_answers_en;
        this.data.images = res.data.data.data.image.map((image) => {
          return { file: null, path: image.url, id: image.id };
        });
        this.imgUrls = res.data.data.data.image.map((image) => image.url);
        this.initialType = res.data.data.data.type;
        this.data.type = this.types?.find(
          (type) => type.value == res.data.data.data.type
        );
        this.data.level = this.levels?.find(
          (level) => level.value == res.data.data.data.level
        );
        console.log(this.data.type);
        // End:: Set Datat
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getCategories();
    this.getDataToEdit();

    this.$nextTick(() => {
      this.data.mobile = "";
    });
  },
};
</script>

<style>
form .input_wrapper.top_label input {
  width: 100% !important;
}
</style>
